<!-- Polaris (fase 5.1, D-G5): the first-time empty state of Contacts. Faded rows of the real contacts table behind
     (the woot's sample contacts, as an illustration, hidden from assistive tech), and the kit's Empty in front with
     the woot's words and its "add contact" action (it asks the page for the "New contact" drawer). -->
<script setup>
import ContactsCard from 'dashboard/components-next/Contacts/ContactsCard/ContactsCard.vue';
import contactContent from 'dashboard/components-next/Contacts/EmptyState/contactEmptyStateContent';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from 'dashboard/components-next/polaris/ui/empty';
import { Table, TableBody } from 'dashboard/components-next/polaris/ui/table';
import Policy from 'dashboard/components/policy.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  showButton: {
    type: Boolean,
    default: true,
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

// The page opens the "New contact" drawer (fase 5.2).
const emit = defineEmits(['add']);
</script>

<template>
  <section
    class="relative flex h-full min-h-[28rem] w-full flex-col overflow-hidden"
    data-contacts-empty
  >
    <div
      class="pointer-events-none max-h-[28rem] overflow-hidden opacity-50"
      aria-hidden="true"
      inert
    >
      <Table>
        <TableBody>
          <ContactsCard
            v-for="contact in contactContent.slice(0, 6)"
            :id="contact.id"
            :key="contact.id"
            inert
            :name="contact.name"
            :email="contact.email"
            :thumbnail="contact.thumbnail"
            :phone-number="contact.phoneNumber"
            :additional-attributes="contact.additionalAttributes"
            :last-activity-at="contact.lastActivityAt"
            :created-at="contact.createdAt"
          />
        </TableBody>
      </Table>
    </div>
    <div
      class="absolute inset-0 flex items-end justify-center bg-gradient-to-t from-polaris-background from-40% to-transparent pb-12"
    >
      <Empty class="flex-none">
        <EmptyHeader>
          <EmptyTitle class="type-polaris-section-title">
            {{ title }}
          </EmptyTitle>
          <EmptyDescription v-if="subtitle">{{ subtitle }}</EmptyDescription>
        </EmptyHeader>
        <Policy v-if="showButton" :permissions="[]">
          <EmptyContent>
            <Button size="sm" @click="emit('add')">
              <span class="i-lucide-plus size-4" aria-hidden="true" />
              {{ buttonLabel }}
            </Button>
          </EmptyContent>
        </Policy>
      </Empty>
    </div>
  </section>
</template>
